import { computed } from 'vue'

export const TOKEN_COOKIE_NAME = 'ftlp_token'
export const USER_INFO_COOKIE_NAME = 'ftlp_user_log_info'
export const TOKEN_EXPIRY_DATE_COOKIE_NAME = 'ftlp_token_max_age'
export const ERROR_FIELD = 2
export const INITIAL_FIELD = 0
export const SUCCESS_FIELD = 1
export const COMPANY_INFO = {
  name: 'FUJITRANS LOGISTICS PHILIPPINES, INC.',
  address:
    '2nd Floor, Building 21 Daystar Industrial Park Brgy. Pulong Sta. Cruz, Sta. Rosa, Laguna, Philippines',
}

export const FIELD_STATUS_BOOTSTRAP_BASE = {
  0: '',
  1: 'is-valid',
  2: 'is-invalid',
}

export const FIELD_STATUS_BASE = {
  0: '',
  1: 'valid',
  2: 'invalid',
}

export const SETUP_STATUSES = [
  { label: 'Active', value: 1 },
  { label: 'Inactive', value: 0 },
]

export const FILE_EXTENSIONS = {
  image: [
    'apng',
    'png',
    'avif',
    'gif',
    'jpg',
    'jpeg',
    'jfif',
    'pjpeg',
    'pjp',
    'png',
    'svg',
    'webp',
  ],
  video: ['mkv', 'flv', 'vob', 'ogg', 'drc', 'avi', 'wmv', 'avchd', 'flv', 'mp4'],
  excel: ['xlsx', 'xlsm', 'xlsb', 'xltx', 'xltm', 'xls', 'xlt', 'xml', 'xlam', 'xla', 'xlw', 'xlr'],
  word: ['doc', 'docm', 'docx', 'dot', 'dotm', 'dotx'],
}

export const ERROR_MESSAGES = {
  invalid_credentials: 'Incorrect username or password.',
}

export const SHIPPING_CONDITIONS = {
  P: 'Port',
  D: 'Door',
}

export const CONDITIONS = ['DP', 'PP', 'DP', 'PD']

export const delivery_history_key_mapping = {
  issued: ['Issued', 'fa-solid fa-receipt'],
  picked_up: ['Picked Up', 'fa-solid fa-box'],
  departed: ['Departed', 'fa-solid fa-truck'],
  in_transit: ['In Transit', 'fa-solid fa-truck-fast'],
  origin_truckyard: ['Origin Truckyard', 'fa-solid fa-warehouse'],
  vessel_loading: ['Vessel Loading', 'fa-solid fa-truck-ramp-box'],
  destination_truckyard: ['Destination Truckyard', 'fa-solid fa-warehouse'],
  out_for_delivery: ['Out for Delivery', 'fa-solid fa-truck-fast'],
  arrived: ['Arrived', 'fa-solid fa-truck-ramp-box'],
  delivered: ['Delivered', 'fa-solid fa-circle-check'],
}

export const PRINT_PDF_PAYLOAD_FORMAT = {
  fontSize: 'fontSize',
  fontFamily: 'fontStyle',
  lineHeight: 'lineHeight',
  format: 'paperSize',
  orientation: 'orientation',
  details: 'details',
}

export const EXCEL_MIME_TYPES = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
  'application/vnd.ms-excel', // .xls
  'text/csv', // .csv
]

export const paginationPayloadFormat = {
  limit: 'countsPerPage',
  page: 'currentPage',
  sort: 'sortDirection',
  key: 'sortKey',
}
export const paginationDataTemplate = {
  currentPage: 1,
  totalItems: 0,
  countsPerPage: 100,
  sortDirection: 'desc',
  sortKey: 'created_at',
}

export const cargoTypeCode = {
  CBU: 'CT007',
  Heavy: 'CT006',
  GeneralCargo: 'invalid',
}

export const PAPER_DIMENSIONS = {
  a0: { width: 33.11, height: 46.81 },
  a1: { width: 23.39, height: 33.11 },
  a2: { width: 16.54, height: 23.39 },
  a3: { width: 11.69, height: 16.54 },
  a4: { width: 8.27, height: 11.69 },
  a5: { width: 5.83, height: 8.27 },
  a6: { width: 4.13, height: 5.83 },
  b4: { width: 9.84, height: 13.9 },
  b5: { width: 6.93, height: 9.84 },
  b6: { width: 4.92, height: 6.93 },
  executive: { width: 7.25, height: 10.5 },
  folio: { width: 8.27, height: 13.0 },
  legal: { width: 8.5, height: 14.0 },
  letter: { width: 8.5, height: 11.0 },
  tabloid: { width: 11.0, height: 17.0 },
}

export const VALIDITY_STATUS_ICON_AND_CLASSES = {
  good: {
    label: 'Good',
    icon: 'circle-check',
    badgeClass: 'bg-success-subtle text-success-emphasis border border-success-subtle',
  },
  near: {
    label: 'Near Expiry',
    icon: 'triangle-exclamation',
    badgeClass: 'bg-warning-subtle text-warning-emphasis border border-warning-subtle',
  },
  expired: {
    label: 'Expired',
    icon: 'circle-xmark',
    badgeClass: 'bg-danger-subtle text-danger-emphasis border border-danger-subtle',
  },
}
